import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Document } from '../models/document.model';
import { Filter } from '../models/filter.model';

@Injectable({
    providedIn: 'root'
})
export class DocumentService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/documents/' + id).toPromise();
    }

    gridView(filter: Filter) {
        return this.httpClient.post('api/documents/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res.data;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createDocument(document: Document) {
        return this.httpClient.post('api/documents/create', document.data).toPromise();
    }

    editDocument(document: Document) {
        return this.httpClient.post('api/documents/edit', document.data).toPromise();
    }

    deleteDocument(ids: Array<Number>) {
        return this.httpClient.post('api/documents/delete', ids).toPromise();
    }

}